import { createEvent, restore, sample } from 'effector'

import { fx } from '../../../libs'
import {
  GatewaysByClient,
  GatewaysByClientResponse,
  Transaction,
  TransactionRequest,
  TransactionResponse,
} from './types'
import { RequestError } from '../../../shared/errorResponse'
import {
  changedDateFormat,
  isAllElementsOfSearchTextNotExist,
} from '../../../libs/utils'
import { transactionRequestStatus } from '../../../pages/billing/const'

const DATE_FIELDS = ['updatedAt']

const mapSearchEntry = (key: string, value: any): [string, any] => {
  if (DATE_FIELDS.includes(key)) {
    const dates = Array.isArray(value)
      ? value.map((date) => (date ? changedDateFormat(date?.$d) : `${date}`))
      : value
    return [key, dates]
  }
  return [key, value?.toLowerCase()]
}

const mapSearchText = (searchText: { [key: string]: string }) => {
  return Object.fromEntries(
    Object.entries(searchText).map(([key, value]) => mapSearchEntry(key, value)),
  )
}

export const transactionsListMounted = createEvent<TransactionRequest>()

export const gatewaysByClientMounted = createEvent<{ clientId: string }>()

export const getTransactionsFailed = createEvent<RequestError | null>()

export const getTransactions = fx<TransactionRequest, TransactionResponse>({
  method: 'GET',
  url: `/transaction_request`,
})

export const getGatewaysByClient = fx<void, GatewaysByClientResponse>({
  method: 'GET',
  url: `/client/{clientId}/gateway`,
})

export const $transactions = restore<Transaction[]>(
  getTransactions.doneData.map((a) => a.body.items),
  [],
)

export const $totalCountOfTransactions = restore(
  getTransactions.doneData.map((a) => a.body.total),
  0,
)

export const $transactionsError = restore<RequestError | null>(
  getTransactionsFailed,
  null,
).reset([transactionsListMounted])

export const $gatewaysByClient = restore<GatewaysByClient[]>(
  getGatewaysByClient.doneData.map((a) => a.body.items),
  [],
)

sample({
  // @ts-ignore
  clock: transactionsListMounted,
  fn: ({
    clientId,
    limit,
    page,
    orderBy,
    orderDirection,
    searchText,
    filters,
  }) => {
    if (orderDirection == 'descend') {
      orderDirection = '-'
    } else if (orderDirection == 'ascend') {
      orderDirection = ''
    }

    let query = {
      limit,
      page,
    }

    if (orderBy != '') {
      // @ts-ignore
      query['order'] = orderDirection + orderBy
    }

    if (filters) {
      //TODO данные мапперы необходимо переписать, когда бэк будет паринимать правильный JSON
      let newObj = Object.keys(filters).reduce((accumulator, key) => {
        if (filters[key as keyof typeof filters] != null) {
          accumulator[
            key !== 'gatewayInternalName'
              ? (key as keyof typeof filters)
              : 'gateway'
          ] =
            key === 'gateway' ||
            key === 'gatewayInternalName' ||
            key === 'status'
              ? filters[key as keyof typeof filters]
              : `${filters[key as keyof typeof filters]}`
        }

        return accumulator
      }, {} as any)

      if (!isAllElementsOfSearchTextNotExist(searchText)) {
        newObj = { ...newObj, ...mapSearchText(searchText) }
      }

      if (newObj.status) {
        if (Array.isArray(newObj.status)) {
          if (
            newObj.status.includes(transactionRequestStatus.accepted()) &&
            !newObj.status.includes(transactionRequestStatus.completed())
          ) {
            newObj.status.push(transactionRequestStatus.completed())
          }
        }
      }

      if (Object.keys(newObj).length) {
        // @ts-ignore
        query['where'] = `${JSON.stringify(newObj)}`
      }
    }

    return {
      query,
      url: '/client/' + clientId + '/transaction_request',
    }
  },
  target: getTransactions,
})

getTransactions.fail.watch(({ error }) =>
  getTransactionsFailed({ code: error.status, message: error.body.message }),
)

getTransactions.done.watch(() => getTransactionsFailed(null))

sample({
  // @ts-ignore
  clock: gatewaysByClientMounted,
  fn: ({ clientId }) => {
    return {
      url: `/client/${clientId}/gateway`,
    }
  },
  target: getGatewaysByClient,
})
